<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.pengajuanLembur }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalPengajuanLembur-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalPengajuanLembur" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaStatusPengajuan-filter>
                <b-form-select v-model="filter.statusPengajuan" :options="optionsStatusPengajuan"></b-form-select>
              </template>
              <template #jumlahJamLembur-filter>
                <b-form-select v-model="filter.jumlahJamLembur" :options="optionsJam"></b-form-select>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Status'"
                    v-b-modal.modal-status
                    @click="data = item"
                    :disabled="item.statusPengajuan != 0 || (!can_approve.includes($store.state.role_aktif.kodeRole) && !item.mitraId)"
                    ><CIcon name="cil-check"
                  /></b-button>
                  <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    @click="data = item"
                    :disabled="approved(item.statusPengajuan) || (!can_approve.includes($store.state.role_aktif.kodeRole) && !item.mitraId)"
                    ><CIcon name="cil-pencil"
                  /></b-button>
                  <b-button
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    @click="data = item"
                    :disabled="approved(item.statusPengajuan) || (!can_approve.includes($store.state.role_aktif.kodeRole) && !item.mitraId)"
                    ><CIcon name="cil-trash"
                  /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input :listKaryawan="listKaryawan" :listMasterLembur="listMasterLembur" :optionsJam="optionsJam" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :listKaryawan="listKaryawan" :listMasterLembur="listMasterLembur" :optionsJam="optionsJam" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-status :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
import modalStatus from "./modalStatus.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
    modalStatus,
  },
  name: "laporanLembur",
  data() {
    return {
      detail: false,
      data: {},
      listKaryawan: [],
      listMasterLembur: [],
      can_approve: ["super", "super_user", "spv", "admin-hrd"],
      items: [],

      filter: {
        tanggalPengajuanLembur: null,
        statusPengajuan: null,
        jumlahJamLembur: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusPengajuan: [
        { value: null, text: "Pilih" },
        { value: "0", text: "Butuh Persetujuan" },
        { value: "1", text: "Telah Disetujui" },
        { value: "2", text: "Ditolak" },
      ],
      optionsJam: [
        { value: null, text: "Pilih" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 30%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalPengajuanLembur",
          label: this.$store.state.table.namaTanggalPengajuanLembur,
          _style: "max-width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "jumlahJamLembur",
          label: this.$store.state.table.jumlahJamLembur,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaNominalLembur",
          label: this.$store.state.table.namaNominalLembur,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          filter: false,
          sorter: false,
        },
        {
          key: "totalNominalLembur",
          label: this.$store.state.table.totalNominalLembur,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          filter: false,
          sorter: false,
        },
        {
          key: "namaStatusPengajuan",
          label: this.$store.state.table.namaStatusPengajuan,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          filter: false,
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  mounted() {
    this.getDatas();
    this.getKaryawan();
    this.getMasterLembur();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalPengajuanLembur"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.statusPengajuan"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.jumlahJamLembur"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    approved(status) {
      return status == 1;
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPengajuanLembur = await vm.$axios.post("/pengajuanLembur/listPerHalaman", {
        ...vm.filter,
        tanggalPengajuanLembur: vm.filter.tanggalPengajuanLembur ? vm.$moment(vm.filter.tanggalPengajuanLembur).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listPengajuanLembur", listPengajuanLembur);
      vm.items =
        listPengajuanLembur.data.status == 200
          ? listPengajuanLembur.data.data.map((x, idx) => {
              vm.optionsStatusPengajuan.forEach((item) => {
                if (item.value == x.statusPengajuan) x.namaStatusPengajuan = item.text;
              });
              return {
                ...x,
                //view
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.pengajuanLemburId,
                namaMitra: x.namaMitra || " - ",
                namaTanggalPengajuanLembur: vm.$moment(x.tanggalPengajuanLembur).format("LL"),
                namaNominalLembur: vm.toNumeric(x.nominalLembur, "idr"),
                totalNominalLembur: vm.toNumeric(x.nominalLembur * x.jumlahJamLembur, "idr"),
                //edit
                karyawan: { dataKaryawanId: x.dataKaryawanId, namaKaryawan: x.namaKaryawan },
                lembur: { id: x.masterLemburId, namaLembur: x.namaLembur },
                tanggalPengajuanLembur: new Date(x.tanggalPengajuanLembur),
              };
            })
          : [];
      vm.totalRows = parseInt(listPengajuanLembur.data.count);
      vm.loading = false;
    },
    async getKaryawan() {
      let vm = this;
      let listKaryawan = await vm.$axios.get("dataKaryawan/listKaryawan");
      console.log("listKaryawan", listKaryawan);
      vm.listKaryawan = listKaryawan.data.status == 200 ? listKaryawan.data.data : [];
    },
    async getMasterLembur() {
      let vm = this;
      let listMasterLembur = await vm.$axios.post("masterLembur/list");
      console.log("listMasterLembur", listMasterLembur);
      vm.listMasterLembur =
        listMasterLembur.data.status == 200
          ? listMasterLembur.data.data.map((x) => {
              return {
                ...x,
                id: x.masterLemburId,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
    toNumeric(number, type) {
      let data = {};
      if (type == "no-idr") {
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        })
          .format(number)
          .slice(3);
      } else {
        if (type == "idr") data = { style: "currency", currency: "IDR" };
        return new Intl.NumberFormat("id-ID", data).format(number);
      }
    },
  },
};
</script>
